import styled from 'styled-components';
import { BasketSelectSectionStyled } from '../BasketRentPaymentSelectionStyled';
import { rem } from 'polished';

export const BasketRentPaymentSelectionDS = styled(BasketSelectSectionStyled)`
    .section {
        border: 1px solid ${({ theme }) => theme.colors.grey16};
        border-radius: ${rem(8)};
        &:hover,
        &:focus-visible,
        &.selected {
            border-color: ${({ theme }) => theme.colors.secondary};
            background: none;
            .inner {
                border-color: ${({ theme }) => theme.colors.secondary};
                border-radius: ${rem(6)};
            }
        }

        &.selected {
            background: ${({ theme }) => theme.colors.grey4};

            .description {
                color: ${({ theme }) => theme.colors.black};
            }
        }

        .title {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};

            .icon {
                border-color: ${({ theme }) => theme.colors.black};

                .selected {
                    width: ${rem(14)};
                    height: ${rem(14)};
                    top: ${rem(4)};
                    left: ${rem(4)};
                }
            }
        }

        .description,
        .primaryText {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            color: ${({ theme }) => theme.colors.black};
        }

        .summary {
            .totalPrice {
                font-size: ${({ theme }) => theme.fontSizes.h4};
            }
            .otherPrices {
                font-size: ${({ theme }) => theme.fontSizes.h5};
                border-color: ${({ theme }) => theme.colors.grey5};
            }
        }
    }
`;
